import { messageBoxSuccess, messageBoxError } from './message-box';

class AddToWishlistIcon {
  public stickyBarIcon = 'js-sticky-bar-wishlist';
  public productDetailIcon = 'js-product-detail-wishlist';
  public trigger: NodeListOf<HTMLLinkElement>;
  public stickyBarTrigger: HTMLLinkElement | null;
  public productDetailTrigger: HTMLLinkElement | null;
  public wishlistIconHeader: HTMLElement | null;
  public wishlistIconHeaderInner: SVGTSpanElement | null | undefined;

  bindings() {
    if (this.trigger) {
      this.trigger.forEach((icon) => {
        icon.addEventListener('click', async (e: Event) => {
          e.preventDefault();

          if (icon.classList.contains('disabled')) {
            return;
          }

          icon.classList.add('disabled');

          const action = icon.dataset.action;
          const teaser = icon.closest('.m-product-list-teaser') as HTMLElement | null;
          const color = teaser?.querySelector('.m-product-list-teaser__colors-item.is--active') as HTMLElement | null;

          const count = JSON.parse(icon.dataset.count || '[]');
          const set = new Set();
          count.forEach((obj: any) => {
            set.add(obj.listId);
          });

          const makeAction = async () => {
            try {
              if (action === 'remove') {
                icon.classList.remove('is-active');
                if (icon.classList.contains(this.stickyBarIcon)) {
                  this.productDetailTrigger?.classList.remove('is-active');
                } else if (icon.classList.contains(this.productDetailIcon)) {
                  this.stickyBarTrigger?.classList.remove('is-active');
                }

                if (this.wishlistIconHeaderInner) {
                  this.wishlistIconHeaderInner.innerHTML = String(Number(this.wishlistIconHeaderInner.innerHTML) - count.length);
                }

                if (this.wishlistIconHeader && this.wishlistIconHeaderInner?.innerHTML == '0') {
                  this.wishlistIconHeader.style.display = 'none';
                }

                const countNewRaw = icon.dataset.count as string;
                let countNew = JSON.parse(countNewRaw);
                let filteredCount: any = [];

                for (const list of count) {
                  const url = new URL(icon.href);
                  url.searchParams.set('listId', list.listId);

                  const res = await fetch(url.href, {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                      'Accept': 'application/json',
                    },
                  });
                  const jsonRes = await res.json()

                  jsonRes.items.forEach((item: any) => {
                    filteredCount = countNew.filter((entry: any) => entry.listId !== item.listId)
                  })

                  countNew = filteredCount;
                }

                icon.dataset.action = 'add';
                icon.href = icon.dataset.addUrl || icon.href;
                icon.dataset.count = JSON.stringify(countNew);
                if (icon.classList.contains(this.stickyBarIcon) && this.productDetailTrigger) {
                  this.productDetailTrigger.dataset.action = 'add';
                  this.productDetailTrigger.href = icon.dataset.addUrl || icon.href;
                  this.productDetailTrigger.dataset.count = JSON.stringify(countNew);
                } else if (icon.classList.contains(this.productDetailIcon) && this.stickyBarTrigger) {
                  this.stickyBarTrigger.dataset.action = 'add';
                  this.stickyBarTrigger.href = icon.dataset.addUrl || icon.href;
                  this.stickyBarTrigger.dataset.count = JSON.stringify(countNew);
                }

                if (color) {
                  color.dataset.isOnWishlist = '';
                }

                icon.classList.remove('disabled');
                if (icon.classList.contains(this.stickyBarIcon)) {
                  this.productDetailTrigger?.classList.remove('disabled');
                } else if (icon.classList.contains(this.productDetailIcon)) {
                  this.stickyBarTrigger?.classList.remove('disabled');
                }

                messageBoxSuccess({
                  contentDe: 'Erfolgreich von Merkliste gelöscht.',
                  contentEn: 'Successfully remove from wishlist.',
                });
              } else {
                icon.classList.add('is-active');
                if (icon.classList.contains(this.stickyBarIcon)) {
                  this.productDetailTrigger?.classList.add('is-active');
                } else if (icon.classList.contains(this.productDetailIcon)) {
                  this.stickyBarTrigger?.classList.add('is-active');
                }

                if (this.wishlistIconHeaderInner) {
                  this.wishlistIconHeaderInner.innerHTML = String(Number(this.wishlistIconHeaderInner.innerHTML) + 1);
                }

                if (this.wishlistIconHeader) {
                  this.wishlistIconHeader.style.display = 'block';
                }

                const res = await fetch(icon.href, {
                  method: 'GET',
                  credentials: 'include',
                  headers: {
                    'Accept': 'application/json',
                  },
                });
                const jsonRes = await res.json()

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push({
                  event: 'add_to_wishlist',
                  ecommerce: {
                    items: [{item_name: jsonRes.items[0].title}],
                    content_type: 'product',
                  }
                });

                const countRaw = icon.dataset.count as string;
                const count = JSON.parse(countRaw);

                jsonRes.items.forEach((item: any) => {
                  count.push({'listId': item.listId})
                })

                icon.dataset.action = 'remove';
                icon.href = icon.dataset.removeUrl || icon.href;
                icon.dataset.count = JSON.stringify(count);
                if (icon.classList.contains(this.stickyBarIcon) && this.productDetailTrigger) {
                  this.productDetailTrigger.dataset.action = 'remove';
                  this.productDetailTrigger.href = icon.dataset.removeUrl || icon.href;
                  this.productDetailTrigger.dataset.count = JSON.stringify(count);
                } else if (icon.classList.contains(this.productDetailIcon) && this.stickyBarTrigger) {
                  this.stickyBarTrigger.dataset.action = 'remove';
                  this.stickyBarTrigger.href = icon.dataset.removeUrl || icon.href;
                  this.stickyBarTrigger.dataset.count = JSON.stringify(count);
                }

                if (color) {
                  color.dataset.isOnWishlist = '1';
                }

                icon.classList.remove('disabled');
                if (icon.classList.contains(this.stickyBarIcon)) {
                  this.productDetailTrigger?.classList.remove('disabled');
                } else if (icon.classList.contains(this.productDetailIcon)) {
                  this.stickyBarTrigger?.classList.remove('disabled');
                }

                messageBoxSuccess({
                  contentDe: 'Erfolgreich zur Merkliste hinzugefügt.',
                  contentEn: 'Successfully added to wishlist.',
                });
              }
            } catch (e) {
              console.error(e);
              if (action === 'remove') {
                icon.classList.add('is-active');
                if (icon.classList.contains(this.stickyBarIcon)) {
                  this.productDetailTrigger?.classList.add('is-active');
                } else if (icon.classList.contains(this.productDetailIcon)) {
                  this.stickyBarTrigger?.classList.add('is-active');
                }

                if (this.wishlistIconHeaderInner) {
                  this.wishlistIconHeaderInner.innerHTML = String(Number(this.wishlistIconHeaderInner.innerHTML) + count.length);
                }

                if (this.wishlistIconHeader) {
                  this.wishlistIconHeader.style.display = 'block';
                }

                messageBoxError({
                  contentDe: 'Es ist ein Fehler aufgetreten. Konnte nicht von Merkliste gelöscht werden.',
                  contentEn: 'An error appeared. Could not remove from wishlist.',
                });
              } else {
                icon.classList.remove('is-active');
                if (icon.classList.contains(this.stickyBarIcon)) {
                  this.productDetailTrigger?.classList.remove('is-active');
                } else if (icon.classList.contains(this.productDetailIcon)) {
                  this.stickyBarTrigger?.classList.remove('is-active');
                }

                if (this.wishlistIconHeaderInner) {
                  this.wishlistIconHeaderInner.innerHTML = String(Number(this.wishlistIconHeaderInner.innerHTML) - 1);
                }

                if (this.wishlistIconHeader && this.wishlistIconHeaderInner?.innerHTML == '0') {
                  this.wishlistIconHeader.style.display = 'none';
                }

                messageBoxError({
                  contentDe: 'Es ist ein Fehler aufgetreten. Konnte nicht zur Merkliste hinzugefügt werden.',
                  contentEn: 'An error appeared. Could not add to wishlist.',
                });
              }

              icon.classList.remove('disabled');
              if (icon.classList.contains(this.stickyBarIcon)) {
                this.productDetailTrigger?.classList.remove('disabled');
              } else if (icon.classList.contains(this.productDetailIcon)) {
                this.stickyBarTrigger?.classList.remove('disabled');
              }
            }
          };

          if (action === 'remove' && count.length > 1 && set.size > 1) {
            const popup = document.querySelector('.m-confirm-popup-remove-from-wishlist');

            popup?.classList.add('m-popup--is-active');

            popup?.querySelector('.a-button:first-child')?.addEventListener('click', () => {
              popup.classList.remove('m-popup--is-active');
            });

            popup?.querySelector('.a-button:last-child')?.addEventListener('click', () => {
              popup.classList.remove('m-popup--is-active');
              makeAction();
            });
          } else {
            makeAction();
          }
        });
      });
    }
  }

  initConfig() {
    if (this.trigger) {
      var wishlistConfigEl = document.querySelector('.js-wishlist-item-config') as HTMLElement | null;
      if (wishlistConfigEl) {
        var wishlistConfigRaw = wishlistConfigEl.dataset.config as string;
        var wishlistConfigParsed = JSON.parse(wishlistConfigRaw);
        var wishlistConfig = wishlistConfigParsed.items;

        if (wishlistConfigParsed.count > 0) {
          var headerWishlistIconEl = document.querySelector('.js-l-header__wishlist-icon') as HTMLElement;
          var headerWishlistIconCountEl = document.querySelector('.js-l-header__wishlist-icon--count') as HTMLElement;
          if (headerWishlistIconEl && headerWishlistIconCountEl) {
            headerWishlistIconCountEl.innerHTML = wishlistConfigParsed.count;
            headerWishlistIconEl.style.display = 'initial';
          }
        }

        this.trigger.forEach((wishlistEl) => {
          var itemId = wishlistEl.dataset.id;
          if (itemId) {
            var item = wishlistConfig[itemId];
            if (item) {
              wishlistEl.classList.add('is-active');
              wishlistEl.href = item.removeUrl;

              var countRaw = wishlistEl.dataset.count as string;
              var count = JSON.parse(countRaw);

              Object.values(item.lists).forEach((listItemId: any) => {
                count.push({'listId': listItemId})
              });
              wishlistEl.dataset.count = JSON.stringify(count);
              wishlistEl.dataset.originalCount = JSON.stringify(count);
              wishlistEl.dataset.originalRemoveUrl = item.removeUrl;
              wishlistEl.dataset.originalAddUrl = item.addUrl;
              wishlistEl.dataset.originalAction = 'remove';
              wishlistEl.dataset.action = 'remove';
            }
          }
        });

        var colorVariants = document.querySelectorAll('.m-product-list-teaser__colors-item') as NodeListOf<HTMLElement>;
        colorVariants.forEach((colorVariantEl: HTMLElement) => {
          var itemId = colorVariantEl.dataset.variantId;
          if (itemId) {
            var item = wishlistConfig[itemId];
            if (item) {
              colorVariantEl.dataset.isOnWishlist = '1';

              var countRaw = colorVariantEl.dataset.count as string;
              var count = JSON.parse(countRaw);

              var listsValues = Object.values(item.lists);

              listsValues.forEach((listItemId: any) => {
                count.push({'listId': listItemId})
              });
              colorVariantEl.dataset.count = JSON.stringify(count);
              if (listsValues.length > 0) {
                colorVariantEl.dataset.listId = listsValues[0] as string;
              }
            }
          }
        });
      }
    }
  }

  cache() {
    this.trigger = document.querySelectorAll('.js-product-teaser-wishlist-button');
    this.stickyBarTrigger = document.querySelector(`.${this.stickyBarIcon}`);
    this.productDetailTrigger = document.querySelector(`.${this.productDetailIcon}`);
    this.wishlistIconHeader = document.querySelector('.l-header__actions-button-wishlist .js-l-header__wishlist-icon');
    this.wishlistIconHeaderInner = this.wishlistIconHeader?.querySelector('tspan');
  }

  init() {
    this.cache();
    this.initConfig();
    this.bindings();
  }
}

export default AddToWishlistIcon;
